
import * as handlebars_family from "../handlebars_family.js";
import "../layout/header_logged_family2.mustache";
import "../layout/pagemenu.mustache";
import "../widget/ads-adder.js";
import "../widget/familycenter.js";
const TPL = handlebars_family.addTemplate("layout/layout_global",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"fw-layout-mobile V4\" style=\"overflow:hidden;position:absolute;left: 0;bottom: 0;top: 0;right: 0;\"> "
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),"displayAdsMobile",{"name":"premiumPermission","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":358},"end":{"line":1,"column":522}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"layout/header_logged_family2"),depth0,{"name":"layout/header_logged_family2","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"@partial-block"),depth0,{"name":"@partial-block","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div> ";
},"4":function(container,depth0,helpers,partials,data) {
    return " <div data-widget=\"widget/ads-adder\" slot-type=\"mobile_leaderboard\" style=\"text-align:center\"></div> ";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"fw-layout\"><header class=\"fw-header\" data-widget=\"widget/familycenter\">  <div></div></header><flexrow class=\"fw-maintable V4\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"@partial-block"),depth0,{"name":"@partial-block","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexrow> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"layout/pagemenu"),depth0,{"name":"layout/pagemenu","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div class=\"print-only\" style=\"line-height:32px;height:32px;\"><img src=\"/images/Print_Footer_Logo_FW.svg\" width=\"108\" height=\"28\" style=\"margin-right:16px;position:relative;top:-2px;\"/> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"family") || (depth0 != null ? lookupProperty(depth0,"family") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"family","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":186},"end":{"line":1,"column":218}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"family")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </div> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"screen") : depth0)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":1,"column":226},"end":{"line":1,"column":832}}})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;